import styled, { css } from 'styled-components'

export const Container = styled.div`
  overflow: auto;
  max-height: 348px;
  margin-top: ${props => props.theme.spacing.sp8};
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  tbody:before {
    line-height: ${props => props.theme.spacing.sp8};
    content: '-';
    display: block;
    color: transparent;
  }
`

export const Row = styled.tr`
  ${props =>
    props.clickable &&
    css`
      cursor: pointer;

      &:hover,
      &:focus-visible {
        background-color: ${props.theme.colors.background.secondary};
      }
    `}

  &:not(:last-child) {
    border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  }
`

export const IndexCell = styled.td`
  text-align: center;
  color: ${props => props.theme.colors.text.subtle};
`

export const Cell = styled.td`
  padding: ${props => props.theme.spacing.sp16};
`

export const NumericCell = styled.td`
  padding: ${props => props.theme.spacing.sp16};
  text-align: right;
`
